import React, { useContext, useState } from "react";

// global state
import { StateContext } from "../../AppStateContext";

// Styling
import "./AddNewClassModals.css";

// Components
import AddClassPropertyModalAdvancedSettings from "./AddClassPropertyModalAdvancedSettings";
import AddNewPropertyModalHeader from "./AddNewPropertyModalHeader";
import AddNewPropertyNameInput from "./AddNewPropertyNameInput";
import AddNewPropertyDescriptionInput from "./AddNewPropertyDescriptionInput";
import AddNewPropertyDataTypes from "./AddNewPropertyDataTypes";
import AddNewPropertyModalButtons from "./AddNewPropertyModalButtons";

// To make component fade in when component is rendered
import FadeIn from "react-fade-in";

// Tooltips label for the dataTypes dropdown
const dataTypes = [
  { value: "string", tooltip: "String" },
  {
    value: "integer",
    tooltip: "Int64",
  },
  {
    value: "boolean",
    tooltip: "Boolean: true/false",
  },
  {
    value: "number",
    tooltip: "Float64",
  },
  {
    value: "date",
    tooltip:
      "Stored as string, validated a RFC 3339 format, e.g. 1937-01-01T12:00:27.87+00:20",
  },
  {
    value: "geoCoordinates",
    tooltip:
      "Weaviate allows you to store geo coordinates related to a thing or action. When querying Weaviate, you can use this type to find items in a radius around this area. A geo coordinate value is a float, and is processed as decimal degree according to the ISO 6709:2008 standard.",
  },
  {
    value: "phoneNumber",
    tooltip:
      "When a phone number is added to this field, the input will be normalized and validated, unlike the single fields as number and string. The data field is an object, as opposed to a flat type similar to geoCoordinates.",
  },
  {
    value: "crossReference",
    tooltip:
      "The cross-reference type is the graph element of Weaviate, you can create a link from one object to another. In the schema you can define multiple classes to which a property can point. Select one or more classes after selecting this option as datatype.",
  },
];

const AddNewPropertyModalContent = ({ setIsAddPropertyModalOpen }) => {
  // global state
  const state = useContext(StateContext);

  const [propObj, setPropObj] = useState({
    name: "",
    description: "",
    dataType: [""],
    vectorizePropertyName: false,
    index: false,
  });

  return (
    <FadeIn transitionDuration={600}>
      <div
        className={
          state.theme === "dark"
            ? "__addNewPropertyModalContent __addNewPropertyModalContentDark"
            : "__addNewPropertyModalContent __addNewPropertyModalContentLight"
        }
      >
        <form className="__addPropertyModalForm">
          <AddNewPropertyModalHeader />
          <AddNewPropertyNameInput propObj={propObj} setPropObj={setPropObj} />
          <AddNewPropertyDescriptionInput
            propObj={propObj}
            setPropObj={setPropObj}
          />
          <AddNewPropertyDataTypes
            dataTypes={dataTypes}
            propObj={propObj}
            setPropObj={setPropObj}
          />
          <AddClassPropertyModalAdvancedSettings
            propObj={propObj}
            setPropObj={setPropObj}
          />
          <AddNewPropertyModalButtons
            propObj={propObj}
            setPropObj={setPropObj}
            setIsAddPropertyModalOpen={setIsAddPropertyModalOpen}
          />
        </form>
      </div>
    </FadeIn>
  );
};

export default AddNewPropertyModalContent;
